import script from "./StartLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./StartLogin.vue?vue&type=script&setup=true&lang=js"

import "./StartLogin.vue?vue&type=style&index=0&id=43b6fefe&lang=scss"

const __exports__ = script;

export default __exports__